import { useEffect } from 'react';
import { PublicHeader } from '@/components/PublicHeader';
import { LandingFooter } from '@/components/landing/LandingFooter';
import { AboutHero } from '@/components/about/AboutHero';
import { OurStory } from '@/components/about/OurStory';
import { MissionValues } from '@/components/about/MissionValues';
import { TeamSection } from '@/components/about/TeamSection';
import { AboutCTA } from '@/components/about/AboutCTA';

const AboutPage = () => {
  useEffect(() => {
    document.title = 'About CampChef Pro | Built for Camp Kitchens';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'CampChef Pro was built by real camp directors and kitchen professionals to simplify meal planning, inventory, and Sysco ordering for camps and retreats.'
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-sand">
      <PublicHeader />
      <main>
        <AboutHero />
        <OurStory />
        <MissionValues />
        <TeamSection />
        <AboutCTA />
      </main>
      <LandingFooter />
    </div>
  );
};

export default AboutPage;
